/** @format */

import React from "react";
// @ts-ignore
import { Helmet, HelmetProvider } from "react-helmet-async";
import { createUseStyles } from "react-jss";
import { guideData, partnerData } from "../constants/GuideData";
// import { FlatButton, Banner, FaqBanner } from "../components/";
import { ThemeType } from "../styles/theme";
import { PartnerData, GuideData } from "../types";
import javascriptHandler from "../apis/javascriptHandler";
import { withVersionParams } from "../HOC/withVersionParams";
import FlatButton from "../components/GuidePage/FlatButton";
import FaqBanner from "../components/GuidePage/FaqBanner";
import Banner from "../components/GuidePage/Banner";
const useStyles = createUseStyles((theme: ThemeType) => ({
   wrap: {
      width: "100%",
      padding: "50px 0px 20px",
      margin: "0 auto",
      "& > h1": {
         fontWeight: theme.medium,
         fontSize: "2.6rem",
         padding: `0px ${theme.gap}px 0px`,
      },
   },
   section: {
      padding: "60px 0px 0px",
      borderBottom: `14px solid ${theme.monoBg}`,
      "& > h2": {
         fontSize: "2.2rem",
         fontWeight: theme.demiLight,
         textAlign: "center",
         marginBottom: 26,
      },
      "&:first-of-type": {
         padding: "30px 0px 40px",
      },
      "&:last-of-type": {
         borderBottom: "none",
      },
   },
   bannerList: {
      padding: "0px 20px",
      position: "relative",
      display: "flex",
      flexDirection: "column",
   },
   logos: {
      display: "grid",
      flexWrap: "wrap",
      columnGap: 10,
      gridTemplateRows: "1fr",
      gridTemplateColumns: "1fr 1fr 1fr",
      padding: `0px ${theme.gap}px!important`,
      marginBottom: "27px!important",
   },
   logo: {
      // width: "33%",
   },
   img: {
      margin: "0 auto",
   },
}));

const GuidePage: React.FC = () => {
   const classes = useStyles();

   return (
      <>
         <HelmetProvider>
            <Helmet>
               <title>가이드</title>
            </Helmet>
         </HelmetProvider>
         <div id="main" className={classes.wrap}>
            <h1>가이드</h1>
            <div className={classes.section}>
               <div className={classes.bannerList}>
                  {/* <EventBanner /> */}
                  {Object.values(guideData)
                     .sort((a: GuideData, b: GuideData) => a.order - b.order)
                     .map((item: GuideData, i: number) => {
                        return <Banner key={i} item={item} />;
                     })}
                  <FaqBanner />
               </div>
            </div>
            <div className={classes.section}>
               <h2>파트너사</h2>
               <ul className={classes.logos}>
                  {partnerData.map((item: PartnerData, i: number) => {
                     return (
                        <li key={i} className={classes.logo}>
                           <img
                              className={classes.img}
                              src={item.src}
                              alt={item.name}
                           />
                        </li>
                     );
                  })}
               </ul>
               <FlatButton
                  text="더 알아보기"
                  onClick={() => {
                     // javascriptHandler.launch();
                     javascriptHandler._callHandler(
                        "Launch",
                        "https://zzeung.id/#/?section=partners"
                     );
                  }}
               />
            </div>
         </div>
      </>
   );
};

export default GuidePage;
